var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"modal-class":"modal-transparent","hide-header":true,"hide-footer":true,"size":"md"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"420","height":"315","src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }